import { useCallback, useRef, useState } from 'react'
import { isMobileSafari, isSafari } from 'react-device-detect'

import useIsTrackEnabled from 'hooks/useIsTrackEnabled/useIsTrackEnabled'

import useVideoContext from '../useVideoContext/useVideoContext'

export default function useLocalAudioToggle() {
    const { room, audioTrack, getLocalAudioTrack, onError } = useVideoContext()

    const { localParticipant } = room || {}
    const previousDeviceIdRef = useRef()
    const isEnabled = useIsTrackEnabled(audioTrack)
    const [isPublishing, setIspublishing] = useState(false)

    const toggleAudioEnabled = useCallback(() => {
        if (isPublishing) return

        if (isMobileSafari || isSafari) {
            // Audio enable and disable doesnt work for safari
            // Destroy existing audio track and recreate

            if (isEnabled && localParticipant) {
                previousDeviceIdRef.current = audioTrack.mediaStreamTrack.getSettings().deviceId
                const trackUnpublish = localParticipant.unpublishTrack(
                    audioTrack
                )
                localParticipant.emit('trackUnpublished', trackUnpublish)
                audioTrack.stop()
            } else {
                setIspublishing(true)
                getLocalAudioTrack(previousDeviceIdRef.current)
                    .then(track => localParticipant?.publishTrack(track))
                    .catch(onError)
                    .finally(() => setIspublishing(false))
            }
        } else if (audioTrack) {
            isEnabled ? audioTrack.disable() : audioTrack.enable()
        }
    }, [
        audioTrack,
        isEnabled,
        localParticipant,
        getLocalAudioTrack,
        isPublishing,
        onError,
    ])

    return [isEnabled, toggleAudioEnabled]
}
